/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GmailMessagePreview } from './GmailMessagePreview';
import {
    GmailMessagePreviewFromJSON,
    GmailMessagePreviewFromJSONTyped,
    GmailMessagePreviewToJSON,
    GmailMessagePreviewToJSONTyped,
} from './GmailMessagePreview';

/**
 * A thread preview from a Gmail search result
 * @export
 * @interface GmailThreadPreview
 */
export interface GmailThreadPreview {
    /**
     * Gmail thread ID
     * @type {string}
     * @memberof GmailThreadPreview
     */
    threadId: string;
    /**
     * Subject of the thread
     * @type {string}
     * @memberof GmailThreadPreview
     */
    subject: string;
    /**
     * Short snippet / preview text
     * @type {string}
     * @memberof GmailThreadPreview
     */
    snippet: string;
    /**
     * All participants in the thread
     * @type {Array<string>}
     * @memberof GmailThreadPreview
     */
    participants: Array<string>;
    /**
     * Number of messages in the thread
     * @type {number}
     * @memberof GmailThreadPreview
     */
    messageCount: number;
    /**
     * Timestamp of the most recent message
     * @type {string}
     * @memberof GmailThreadPreview
     */
    lastMessageDate: string;
    /**
     * Individual message previews
     * @type {Array<GmailMessagePreview>}
     * @memberof GmailThreadPreview
     */
    messages: Array<GmailMessagePreview>;
}

/**
 * Check if a given object implements the GmailThreadPreview interface.
 */
export function instanceOfGmailThreadPreview(value: object): value is GmailThreadPreview {
    if (!('threadId' in value) || value['threadId'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('snippet' in value) || value['snippet'] === undefined) return false;
    if (!('participants' in value) || value['participants'] === undefined) return false;
    if (!('messageCount' in value) || value['messageCount'] === undefined) return false;
    if (!('lastMessageDate' in value) || value['lastMessageDate'] === undefined) return false;
    if (!('messages' in value) || value['messages'] === undefined) return false;
    return true;
}

export function GmailThreadPreviewFromJSON(json: any): GmailThreadPreview {
    return GmailThreadPreviewFromJSONTyped(json, false);
}

export function GmailThreadPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): GmailThreadPreview {
    if (json == null) {
        return json;
    }
    return {
        
        'threadId': json['threadId'],
        'subject': json['subject'],
        'snippet': json['snippet'],
        'participants': json['participants'],
        'messageCount': json['messageCount'],
        'lastMessageDate': json['lastMessageDate'],
        'messages': ((json['messages'] as Array<any>).map(GmailMessagePreviewFromJSON)),
    };
}

export function GmailThreadPreviewToJSON(json: any): GmailThreadPreview {
    return GmailThreadPreviewToJSONTyped(json, false);
}

export function GmailThreadPreviewToJSONTyped(value?: GmailThreadPreview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threadId': value['threadId'],
        'subject': value['subject'],
        'snippet': value['snippet'],
        'participants': value['participants'],
        'messageCount': value['messageCount'],
        'lastMessageDate': value['lastMessageDate'],
        'messages': ((value['messages'] as Array<any>).map(GmailMessagePreviewToJSON)),
    };
}

